module.exports = __webpack_public_path__ + "static/dp-princip-1-70a4d2af1e1a95b59de00762c74d5862.svg";